var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CommonHeader',{staticClass:"main_head_block",scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('span',{staticClass:"module_heading"},[_vm._v(_vm._s(_vm.$route.params.campaignId ? "Edit" : "Add New")+" Campaign")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }